import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import Modal from '../../../components/Modal';

const DeleteAssessmentModal = ({
  isOpen,
  onClose,
  onDelete,
  references = [],
  loadingReferences = false,
}) => {
  const hasReferences = references && references.length > 0;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Assessment"
      size="sm"
      footer={
        <>
          <button
            onClick={onClose}
            className={`px-4 py-2 border rounded-lg text-sm transition-colors border-[#919191]/40 text-[#53545a] hover:bg-[#919191]/5`}
          >
            Cancel
          </button>
          <button
            onClick={onDelete}
            className="px-4 py-2 bg-[#F47F2E] text-white rounded-lg text-sm font-medium hover:bg-[#e06a1f] transition-colors"
          >
            Delete Assessment
          </button>
        </>
      }
    >
      <div className="text-center py-4">
        <div className="w-16 h-16 bg-[#F47F2E]/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <FiTrash2 className="text-[#F47F2E] text-2xl" />
        </div>
        <h3 className={`text-lg font-medium mb-2 text-[#53545a]`}>Are you sure?</h3>
        <p className="text-[#919191]">
          You are about to delete this assessment. This action cannot be undone.
        </p>

        {loadingReferences && (
          <p className="text-sm text-[#919191] mt-4">Checking related records…</p>
        )}

        {!loadingReferences && hasReferences && (
          <div className="mt-5 text-left bg-[#F47F2E]/5 border border-[#F47F2E]/20 rounded-lg p-4">
            <p className="text-sm font-medium text-[#53545a] mb-2">
              The following related records will also be deleted:
            </p>
            <ul className="space-y-1">
              {references.map((ref) => (
                <li
                  key={ref.label}
                  className="flex items-center justify-between text-sm text-[#53545a]"
                >
                  <span>{ref.label}</span>
                  <span className="font-semibold bg-[#F47F2E]/15 text-[#e06a1f] rounded-full px-2.5 py-0.5 text-xs">
                    {ref.count}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DeleteAssessmentModal;
